/**
 * Le jour du SERVEUR — la seule horloge de l'application.
 *
 * L'en-tête affichait « aujourd'hui » d'après l'horloge du navigateur, alors que
 * les retards et la « prochaine » intervention sont calculés à Paris côté
 * serveur. Deux horloges pour un même mot : un poste mal réglé, ou simplement
 * situé ailleurs, annonçait un autre jour que celui qui décide.
 *
 * La valeur est demandée une fois par chargement de page et gardée en mémoire :
 * `/api/version` est public et ne coûte rien.
 */

interface VersionServeur {
  readonly version: string;
  readonly aujourdHui?: string;
  readonly fuseau?: string;
}

let cache: Promise<VersionServeur | undefined> | undefined;

async function lireVersion(): Promise<VersionServeur | undefined> {
  try {
    const reponse = await fetch('/api/version', { headers: { Accept: 'application/json' } });
    if (!reponse.ok) return undefined;
    return (await reponse.json()) as VersionServeur;
  } catch {
    // Pas de réseau, pas de version : l'écran ne doit pas casser pour autant.
    return undefined;
  }
}

/** Version et jour du serveur, demandés au plus une fois. */
export function versionDuServeur(): Promise<VersionServeur | undefined> {
  cache ??= lireVersion();
  return cache;
}

/** Remise à zéro du cache (épreuves uniquement). */
export function oublierVersion(): void {
  cache = undefined;
}
